import * as Ariakit from '@ariakit/react';
import { forwardRef } from '@wordpress/element';
import warning from '@wordpress/warning';
import { useCompositeContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompositeItem = forwardRef(function UnforwardedCompositeItem(props, ref) {
  const context = useCompositeContext();

  // @ts-expect-error The store prop is undocumented and only used by the
  // legacy compat layer. The `store` prop is documented, but its type is
  // obfuscated to discourage its use outside of the component's internals.
  const store = props.store ?? context.store;
  if (!store) {
    globalThis.SCRIPT_DEBUG === true ? warning('Composite.Item: Missing composite state. Render inside Composite to enable composite keyboard behavior.') : void 0;
  }
  return /*#__PURE__*/_jsx(Ariakit.CompositeItem, {
    store: store,
    ...props,
    ref: ref
  });
});